import React from 'react';
import $ from 'jquery';
import "bootstrap";
import Info from "./info/Info";
import _ from 'lodash';
import t from '../../i18n/I18n';
import Portal from "../../common/Portal";
import './../S3Upload.css';
import TextWithEllipsis from '../../common/TextWithEllipsis';
import DropDown2 from '../../common/form/DropDown2';
import S3Util from '../../util/S3Util';
import { ThemeSetup } from '../../themes/ThemeSetup';
import { CloudCredentialsForTransfer } from '../../autogenerated/ZoomBridge';

const debug = require('debug')('wc:assets:S3ConfigForm');
type Props = {
  s3BucketName: string,
  s3BucketPath: string,
  s3AccessId: string,
  s3AccessKey: string,
  region:string,
  onChange: Function,
  isBrowseExtAsset: boolean
};
type State = {
  s3BucketName: string,
  s3BucketPath: string,
  s3AccessId: string,
  s3AccessKey: string,
  region:string,
};
export default class S3ConfigForm extends React.Component<Props, State> {
  state = {s3BucketName: '', s3BucketPath: '', s3AccessId: '', s3AccessKey: '',region:'',regions:[{label:"",value:""}], showAccessKey:false, isBucketFocused: false};
  uuid: number;
  constructor(props){
    super(props);
    this.uuid = 1234;
  }

  componentDidMount() {
    $('[data-toggle="tooltip"]').tooltip();
    const {s3BucketName, s3BucketPath, s3AccessId, s3AccessKey, region} = this.props;
    if (s3BucketName != '' || s3BucketPath != '' || s3AccessId != '' || s3AccessKey != '') {
      this.setState({s3BucketName, s3BucketPath, s3AccessId, s3AccessKey});
    }
    
    this.getS3Regions();
    this.getCloudCredentialsForTransfer();
  }

  getCloudCredentialsForTransfer (){
    const {s3BucketName} = this.props;
    S3Util.getCloudCredentialsForTransfer((err, credentials)=>{
      if(!err){
        const credentialsList = credentials.getCloudCredentials();
        this.setState({credentialsList}, () => {
          if(this.props.isBrowseExtAsset) {
           let options =  _.filter(credentialsList, (cloudCredentials: CloudCredentialsForTransfer)=>  cloudCredentials.getContainerName() === s3BucketName);
           if(options.length) this.fillCredentials(options[0]);
          }
        });
      }
    });
  }

  getS3Regions () {
    S3Util.getS3Regions((err,regions)=>{
      if(!err){
        this.setState({regions})
        this.setState({region:''});
        this.props.onChange({ region:'' });
      }
    });
  }

  onChange = (e) => {
    let value =  e.target.value;
    if(e.target.name == 's3BucketName'){
      value = this.checkBucketNameValidation(value);
    }else if(e.target.name == 's3BucketPath'){
      value = this.removeExtraSlash(value);
    }else if(e.target.name == 's3AccessId' || e.target.name == 's3AccessKey'){
      value = this.removeSpaces(value);
    }
    this.setState({ [e.target.name]: value });
    this.props.onChange({ [e.target.name]: value });
  };

  removeExtraSlash = (value) => {
    return value.replace(/\/\/+/g, '/');
  }

  removeSpaces = (value):string => {
    return value ? value.replace(/\s/g,'') : value;
  }

  checkBucketNameValidation = (bucketName):string => {
    return bucketName.replace(/[&\/\\#,+()$~%.'":*?<>{}_=]/g, '');
  }

  onRegionChange = (value) => {
   this.setState({region:value});
   this.props.onChange({ region:value });
  };

  toggleShowKey=():void=>{
    const showAccessKey:boolean = this.state.showAccessKey;
    this.setState({showAccessKey:!showAccessKey})
  }

  onBucketFocus = () => {
    this.setState({
      isBucketFocused: true
    });
  };
  onBucketBlur = (e) => {
    this.setState({
      isBucketFocused: false
    });
    this.onChange(e);
  };

  fillCredentials = (option) => {
    const {isBrowseExtAsset, s3BucketPath, s3BucketName} = this.props;
    if(!this.props.isBrowseExtAsset) {
      this.setState({
        s3BucketName: option.getContainerName(),
        s3BucketPath: option.getPath()
      });
    }
    
    this.props.onChange({ ['s3BucketPath']:  isBrowseExtAsset ? s3BucketPath : option.getPath() }); // TODO- Need to find better way to update this prop
    if(isBrowseExtAsset) {
      this.props.onChange({['s3BucketName']: this.checkBucketNameValidation(s3BucketName)});
    }
    if(option.getLocation()){
      this.onRegionChange(option.getLocation());
    } 
    this.fillAccessDetails(option);
  }

  fillAccessDetails = (option) => {
    let {accessId, accessKey} = this.state
    accessId = option.getUserName() ? this.removeSpaces(option.getUserName()) : accessId;
    accessKey = option.getPassword() ? this.removeSpaces(option.getPassword()) : accessKey;
    this.setState({
      s3AccessId: accessId,
      s3AccessKey: accessKey
    });
    option.getUserName() ? this.props.onChange({ ['s3AccessId']: accessId}) : null; // TODO- Need to find better way to update this prop
    option.getPassword() ? this.props.onChange({ ['s3AccessKey']: accessKey}) : null; // TODO- Need to find better way to update this prop
  }

  renderAutoFillOptions = (type) => {
    const credentialsList = this.state.credentialsList;
    if(credentialsList && credentialsList.length > 0){
      return (
        <div className="autofill-options">
          {credentialsList.map((option, i) => (
            <div key={'option'+i} onMouseDown={() => {this.fillCredentials(option)}} className='autofill-item' >
              <TextWithEllipsis text={option.getContainerName()+'/'+option.getPath()}/>
            </div>
          ))}
        </div>
      );
    }else{
      return null;
    }
  }

  render() {
    const { s3BucketName, s3BucketPath, s3AccessId, s3AccessKey, showAccessKey, region, regions, isBucketFocused, credentialsList } = this.state;
    const {isBrowseExtAsset} = this.props;
    const bucketPlaceHolder = (credentialsList && credentialsList.length > 0) ? 'Type or select from list' : '';
    let completeS3URL = s3BucketName+ (s3BucketPath ? `/${s3BucketPath}` : '');
    completeS3URL = this.removeExtraSlash(completeS3URL);

    return (
      <div name="S3ConfigForm">
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col">
                <div className="form-group" style={{position: "relative"}}>
                  <div className="flex-row">
                    <label>{t('AMAZON_S3_BUCKET_NAME')}</label>
                    <Info uuid={this.uuid++}>{<span>{t('SPECIFY_AMAZON_BUCKET_NAME')} <Link hrefLink="https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingBucket.html" text={t('HOW_FIND_AMAZON_BUCKET')}/></span>}</Info>
                  </div>
                  <input
                    type="text"
                    name="s3BucketName"
                    autoComplete="off"
                    value={s3BucketName}
                    onChange={this.onChange}
                    className="form-control"
                    onBlur={this.onBucketBlur}
                    onFocus={() => {
                      if(!isBrowseExtAsset)
                      this.onBucketFocus();}}
                    placeholder={bucketPlaceHolder}
                    readOnly = {isBrowseExtAsset}
                  />
                  {isBucketFocused ?
                        this.renderAutoFillOptions('s3BucketName')
                      : null}
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <div className="flex-row">
                    <label>{t('PATH')}</label>
                    <Info uuid={this.uuid++}><span>{this.props.pathToolTip}</span>
                    </Info>

                  </div>
                  <input
                    type="text"
                    name="s3BucketPath"
                    autoComplete="off"
                    value={s3BucketPath}
                    onChange={this.onChange}
                    className="form-control"
                    onBlur={this.onBlur}
                    readOnly = {isBrowseExtAsset}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 s3-url-link">
            <small style={{ display:'flex' }}>
              <span className="s3-url-base">https://s3.amazonaws.com/</span>
              <TextWithEllipsis text={completeS3URL}/>
            </small>
          </div>
          <div className="col-12">
          
            <div className="row">
               <div className="col">
                <div className="form-group">
                  <div>
                    <div className="flex-row">
                      <label>{t('S3_ACCESS_ID')}</label>
                      <Info uuid={this.uuid++}> <span>{t('CREATE_NEW_S3_USER')}<Link hrefLink="https://docs.aws.amazon.com/AmazonS3/latest/gsg/SigningUpforS3.html" text={t('HOW_CREATE_S3_USER')}/></span></Info>
                    </div>
                  </div>
                  <input
                    type="text"
                    name="s3AccessId"
                    autoComplete="on"
                    value={s3AccessId}
                    onChange={this.onChange}
                    className="form-control"
                    onBlur={this.onBlur}
                  />
           
                </div>
               </div>
               <div className="col">
                 <div className="form-group">
                  <div>
                    <div className="flex-row">
                      <label>{t('REGION')}</label>
                    </div>
                  </div>
                   <DropDown2 options={regions} value={region} onChange={this.onRegionChange} />
                </div>
               </div>
              </div>
            
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>{t('S3_SECRET_ACCESS_KEY')}</label>
              <div className="input-group mb-3 ">
              <input
                type={showAccessKey ?"text": "password"}
                name="s3AccessKey"
                value={s3AccessKey}
                autoComplete="on"
                onChange={this.onChange}
                className="form-control s3-access-key"
                onBlur={this.onBlur}
              />
                <div className="show-access-key" onClick={this.toggleShowKey}>
                  <span className="input-group-text s3-eye-icon" style={{padding:"5px"}}>
                    <img src={showAccessKey ?  ThemeSetup.getImageURL('eye_black.svg'):ThemeSetup.getImageURL('eye_gray.svg')} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

type linkProps ={
   hrefLink: string,
   text: string
}
const Link = (props: linkProps) => {
  return(
    <a href={props.hrefLink} target="_blank">{props.text}</a>
  )
}
